import { render, staticRenderFns } from "./china-map.vue?vue&type=template&id=4a22f53b&"
import script from "./china-map.vue?vue&type=script&lang=js&"
export * from "./china-map.vue?vue&type=script&lang=js&"
import style0 from "./china-map.vue?vue&type=style&index=0&id=4a22f53b&prod&lang=less&module=true&"
import style1 from "./china-map.vue?vue&type=style&index=1&id=4a22f53b&prod&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports